import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modalCancelSubscription" }
const _hoisted_2 = { class: "modalCancelSubscription_wrapper" }
const _hoisted_3 = { class: "modalCancelSubscription_close" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_8803_33633)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.0001 12.3503L18.9503 7.40015C19.4058 6.94461 20.1444 6.94461 20.5999 7.40015C21.0555 7.85569 21.0555 8.59427 20.5999 9.04982L15.6498 14L20.5999 18.9502C21.0555 19.4057 21.0555 20.1443 20.5999 20.5998C20.1444 21.0554 19.4058 21.0554 18.9503 20.5998L14.0001 15.6496L9.04994 20.5998C8.5944 21.0554 7.85582 21.0554 7.40027 20.5998C6.94473 20.1443 6.94473 19.4057 7.40027 18.9502L12.3504 14L7.40027 9.04982C6.94473 8.59427 6.94473 7.85569 7.40027 7.40015C7.85582 6.94461 8.5944 6.94461 9.04994 7.40015L14.0001 12.3503Z",
      fill: "#203454"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_8803_33633" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "28",
        height: "28",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "modalCancelSubscription_title" }
const _hoisted_7 = { class: "modalCancelSubscription_subTitle" }
const _hoisted_8 = { class: "modalCancelSubscription_textAreaLabel" }
const _hoisted_9 = { class: "modalCancelSubscription_actions actions" }
const _hoisted_10 = { class: "actions_wrapper" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_4275_14876)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.9535 5.99919H15.75C16.1478 5.99919 16.5294 6.15723 16.8107 6.43853C17.092 6.71984 17.25 7.10137 17.25 7.49919V10.4992C17.25 10.897 17.092 11.2785 16.8107 11.5599C16.5294 11.8412 16.1478 11.9992 15.75 11.9992H14.9535C14.7707 13.4492 14.0649 14.7826 12.9688 15.7492C11.8727 16.7158 10.4615 17.2492 9 17.2492V15.7492C10.1935 15.7492 11.3381 15.2751 12.182 14.4312C13.0259 13.5873 13.5 12.4427 13.5 11.2492V6.74919C13.5 5.55572 13.0259 4.41113 12.182 3.56721C11.3381 2.7233 10.1935 2.24919 9 2.24919C7.80653 2.24919 6.66193 2.7233 5.81802 3.56721C4.97411 4.41113 4.5 5.55572 4.5 6.74919V11.9992H2.25C1.85218 11.9992 1.47064 11.8412 1.18934 11.5599C0.908035 11.2785 0.75 10.897 0.75 10.4992V7.49919C0.75 7.10137 0.908035 6.71984 1.18934 6.43853C1.47064 6.15723 1.85218 5.99919 2.25 5.99919H3.0465C3.22952 4.54936 3.93531 3.21615 5.03143 2.2497C6.12755 1.28325 7.53866 0.75 9 0.75C10.4613 0.75 11.8724 1.28325 12.9686 2.2497C14.0647 3.21615 14.7705 4.54936 14.9535 5.99919ZM2.25 7.49919V10.4992H3V7.49919H2.25ZM15 7.49919V10.4992H15.75V7.49919H15ZM6.47815 12.1949C6.10266 12.0208 5.99771 11.5536 6.21708 11.2026C6.43678 10.8511 6.89854 10.7511 7.28163 10.9095C7.82423 11.1338 8.40799 11.2501 9 11.2492C9.59201 11.2501 10.1758 11.1338 10.7184 10.9095C11.1015 10.7511 11.5632 10.8511 11.7829 11.2026C12.0023 11.5536 11.8973 12.0208 11.5218 12.1949C10.7344 12.5601 9.87397 12.7505 9 12.7492C8.12603 12.7505 7.26557 12.5601 6.47815 12.1949Z",
      fill: "#3C92FE"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_4275_14876" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "18",
        height: "18",
        fill: "white"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_textarea = _resolveComponent("ac-textarea")!
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_ac_modal = _resolveComponent("ac-modal")!

  return (_openBlock(), _createBlock(_component_ac_modal, {
    "model-value": true,
    "onUpdate:modelValue": _ctx.closeModalSubscription,
    "backdrop-close": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "modalCancelSubscription_closeBtn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModalSubscription && _ctx.closeModalSubscription(...args)))
            }, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('cancelSubscribeBtn.ready')), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.cancelPopupText), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('subscription.reasonUnsubscribing')), 1),
          _createVNode(_component_ac_textarea, {
            class: "modalCancelSubscription_textarea -light-gray",
            name: "reason-text",
            modelValue: _ctx.reasonText,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reasonText) = $event)),
            modelModifiers: { trim: true },
            height: "150px",
            placeholder: _ctx.$t('subscription.textareaPlaceholder')
          }, null, 8, ["modelValue", "placeholder"]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_ac_button, {
                variant: "outlined",
                class: "modalCancelSubscription_btn -ready",
                disabled: _ctx.isReadyBtnDisabled,
                onClick: _ctx.cancelSubscription
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.readyBtnText), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _createVNode(_component_ac_button, {
              class: "modalCancelSubscription_btn -support",
              variant: "outlined",
              onClick: _ctx.contactToSupport
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('contactSupport')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onUpdate:modelValue"]))
}